import api from "@/utils/api";

export type SalesStage = "visit" | "product" | "cart" | "checkout" | "purchase";

const recent = new Map<string, number>();

function storageId(storage: Storage, key: string) {
  const existing = storage.getItem(key);
  if (existing) return existing;
  const created =
    typeof crypto !== "undefined" && "randomUUID" in crypto
      ? crypto.randomUUID().replace(/-/g, "")
      : `${Date.now().toString(36)}${Math.random().toString(36).slice(2, 12)}`;
  storage.setItem(key, created);
  return created;
}

export function trackSalesEvent(
  storeUrl: string | undefined,
  stage: SalesStage,
) {
  if (!storeUrl || typeof window === "undefined") return;
  const params = new URLSearchParams(window.location.search);
  if (params.get("preview") === "1") return;

  const stampKey = `${storeUrl}:${stage}`;
  const now = Date.now();
  if (now - (recent.get(stampKey) || 0) < 8000) return;
  recent.set(stampKey, now);

  const visitorId = storageId(window.localStorage, "sq_visitor");
  const sessionId = storageId(window.sessionStorage, "sq_session");

  api
    .post(`/api/public/stores/${encodeURIComponent(storeUrl)}/events`, {
      stage,
      visitorId,
      sessionId,
      path: window.location.pathname,
      referrer: document.referrer || "",
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone || "",
      language: navigator.language || "",
      localHour: new Date().getHours(),
    })
    .catch(() => {});
}
